module.exports = __webpack_public_path__ + "static/media/Illus-Fall@3x.2dae2554.png";